import * as bootstrap from 'bootstrap'

import './directives'

import './components'
import './layout'

import App from './app'

App.mount('#app')

window.__bs__ = {
	...bootstrap,
}
